// File: src/components/general/Tip/Tip.tsx
// Purpose: General UI component or utility

import React from 'react';
import styled from 'styled-components';

type TipProps = {
  children: React.ReactNode;
  fullWidth?: boolean;
};

const TipWrapper = styled.div<TipProps>`
  display: flex;
  align-items: center;
  background: ${({ theme }) => theme.colors.surface};
  padding: ${({ theme }) => theme.spacing.sm} ${({ theme }) => theme.spacing.md};
  border-radius: ${({ theme }) => theme.radii.md};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-weight: ${({ theme }) => theme.fonts.fontWeightRegular};
  font-size: ${({ theme }) => theme.fonts.fontSize};
  line-height: 16px;
  max-width: ${({ fullWidth }) => (fullWidth ? '100%' : 'fit-content')};
  margin-top: ${({ theme }) => theme.spacing.lg};
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'auto')};
  
  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    width: 100%;
  }
`;

const TipLabel = styled.span`
  margin-right: ${({ theme }) => theme.spacing.sm};
  font-size: 11px;
  text-transform: uppercase;
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.buttonText};
  padding: ${({ theme }) => theme.spacing.xs} ${({ theme }) => theme.spacing.sm};
  border-radius: ${({ theme }) => theme.radii.sm};
`;

const Tip: React.FC<TipProps> = ({ children, fullWidth = false }) => {
  return (
    <TipWrapper fullWidth={fullWidth}>
      <TipLabel>Tip</TipLabel>
      {children}
    </TipWrapper>
  );
};

export default Tip;
